import RankKeywordStore from "./store";
import { IRankKeywordConfig, IResItem } from "../interface/IRankKeyword";

class RankKeyword {
  #config = {} as IRankKeywordConfig;
  #store: RankKeywordStore  

  constructor(config: IRankKeywordConfig) {
    this.#config = config;
    this.#store = new RankKeywordStore(this.#config);
  }

  async getList() {
    return await this.#store.getList();
  }
}

export default RankKeyword;